import { Injectable } from '@angular/core';
import { IWidgetData } from '../interfaces/widget/IWidgetData';

@Injectable({ providedIn: 'root' })
export class CarouselInjectedData {
    data: IWidgetData | any;
}
